import settings from '../_settings.js';
import Bounds from './Bounds';
import Point from './Point.js';

export default class Size {
    width = null;

    height = null;

    constructor(width = null, height = null, isScaled = false) {
        this.setSize(width, height, isScaled);
    }

    setWidth(width, isScaled = false) {
        this.width = isScaled ? (width / settings.scalingFactor) : width;
    }

    setHeight(height, isScaled = false) {
        this.height = isScaled ? (height / settings.scalingFactor) : height;
    }

    setSize(width, height, isScaled = false) {
        this.setWidth(width, isScaled);
        this.setHeight(height, isScaled);
    }

    resizeBy(factor) {
        factor += 1;
        return new Size(
            this.isScaled ? ((factor * this.width) / settings.scalingFactor) : factor * this.width,
            this.isScaled ? ((factor * this.height) / settings.scalingFactor) : factor * this.height,
            this.isScaled
        );
    }

    get scaled() {
        return {
            width: (this.width * settings.scalingFactor) + settings.spriteOverlay,
            height: (this.height * settings.scalingFactor) + settings.spriteOverlay,
        };
    }

    turn() {
        return new Size(
            this.height,
            this.width,
            this.isScaled
        );
    }

    toBounds(originPoint) {
        if (!(originPoint instanceof Point)) {
            throw new Error('originPoint must be an instance of Point');
        }

        const bounds = new Bounds();
        bounds.addPoint(originPoint);
        bounds.addPoint(new Point(
            originPoint.x + this.width,
            originPoint.y + this.height,
        ));

        return bounds;
    }
}
